import { Component, OnInit } from '@angular/core';
import { RestrictedWordService } from './restricted-word.service';
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { PageEvent as PageEvent } from '@angular/material/paginator';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { AddEditRestrictedWordComponent } from './add-edit-restricted-word/add-edit-restricted-word.component';

@Component({
  selector: 'app-restricted-words-management',
  templateUrl: './restricted-words-management.component.html',
  styleUrls: ['./restricted-words-management.component.css']
})
export class RestrictedWordsManagementComponent implements OnInit {

  isloading: boolean = false;
  prams = {
    pagination: {
      start: 0,
      number: 10,
    },
    search: {
      restrictedText: ''
    },

  };

  dataLength: any;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['restrictedText', 'createdBy', 'creationDate', 'action'];
  constructor(
    public dialog: MatDialog,
    private restrictedWordService: RestrictedWordService
  ) { }

  ngOnInit() {
    this.getAllRestrictWords()
  }


  getAllRestrictWords() {
    this.restrictedWordService.getAllRestrictWords(this.prams).subscribe((res: any) => {
      this.dataSource = new MatTableDataSource(res.data);
      this.dataLength = res.totalCount;
    }), err => {
      this.restrictedWordService.openNotifyError(err.error.message)
    }
  }


  public changePage(event: PageEvent) {
    this.prams.pagination.start = event.pageIndex;
    this.prams.pagination.number = event.pageSize;
    this.getAllRestrictWords()
  }


  addNewWord() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true;
    dialogConfig.minWidth = '600px';
    dialogConfig.maxWidth = '600px';
    dialogConfig.data = { id: 0 };

    dialogConfig.disableClose = false;

    this.dialog.open(AddEditRestrictedWordComponent, dialogConfig).afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.getAllRestrictWords()
          }
        }
      )


  }

  editWord(id: any, word: any) {

    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true;
    dialogConfig.data = { id: id  ,  restrictedText:word};
    dialogConfig.minWidth = '600px';
    dialogConfig.maxWidth = '600px';
    dialogConfig.disableClose = false;

    this.dialog.open(AddEditRestrictedWordComponent, dialogConfig).afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.getAllRestrictWords()
          }
        }
      )


  }

  deleteWord(id: any) {
    this.restrictedWordService.deleteRestrictWord(id).subscribe((res: any) => {
      this.restrictedWordService.openNotifySuccess('Deleted successfully  ')
      this.getAllRestrictWords()


    }), err => {
      this.restrictedWordService.openNotifyError(err.error.message)

    }
  }
}
